var chunkToChildrenMap = {
	"643": [
		141,
		151,
		544,
		839
	],
	"931": [
		544,
		839
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}, () => {

}));